// modules
import { createAction } from 'redux-actions'

// actions

export const setSummaryList = createAction('SET_SUMMARY_LIST')
export const setDetailedList = createAction('SET_DETAILED_LIST')

export const resetCaseManagerCensus = createAction('RESET_CASE_MANAGERS_CENSUS')
